import { Injectable } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { distinctUntilChanged, filter, map, Observable, switchMap } from 'rxjs';
import { AbstractFeatureUIModel } from '../models/abstract-feature.model';
import { Y42RouterService } from '../routing/y42-router.service';
import { FeatureAggregationService } from './feature-aggregation.service';

@Injectable({ providedIn: 'root' })
export class FeatureAggregationQuery {
  constructor(
    private readonly featureAggregationService: FeatureAggregationService,
    private readonly routerService: Y42RouterService,
  ) {}

  readonly activeFeature$ = this.routerService.events.pipe(
    filter((evt) => evt instanceof NavigationEnd),
    map(() => this.featureAggregationService.getActiveFeatureFromURL()),
    filter(Boolean),
    distinctUntilChanged((a, b) => a.featureType === b.featureType),
  );

  readonly activeQuery$ = this.activeFeature$.pipe(map((def) => def.query));
  readonly active$: Observable<AbstractFeatureUIModel | null> = this.activeQuery$.pipe(
    switchMap((query) => query.active$),
    map((active) =>
      active
        ? {
            ...active,
            typeIcon: active.typeIcon || this.featureAggregationService.getLogoByFeatureType(active.featureType),
            typeLabel: active.typeLabel || this.featureAggregationService.getLabelByFeatureType(active.featureType),
          }
        : null,
    ),
  );
}
